import { Ref, ref } from "vue";

export const CLASIFICACION_EQUIPOS = [
  {
    clasificacion: "todos",
    label: "Todos",
    logo: require("@/assets/AlfaPack_Logo.png"),
    alt: "AlfaPack_Logo.png",
  },
  {
    clasificacion: "cvc",
    label: "Envasado de tabletas",
    logo: require("@/assets/CVC_logo.png"),
    alt: "CVC_logo.png",
  },
  {
    clasificacion: "innovatech",
    label: "Equipos pharma",
    logo: require("@/assets/Innovatech_logo.png"),
    alt: "Innovatech_logo.png",
  },
  {
    clasificacion: "serpa",
    label: "Encartonadoras y pallets",
    logo: require("@/assets/Serpa_logo.png"),
    alt: "Serpa_logo.png",
  },
  {
    clasificacion: "correct",
    label: "Codificadores",
    logo: require("@/assets/Correct_Pack_logo.png"),
    alt: "Correct_Pack_logo.png",
  },
  {
    clasificacion: "riqtech",
    label: "Selladoras de bolsas",
    logo: require("@/assets/Riqtech_logo.png"),
    alt: "Riqtech_logo.png",
  },
  {
    clasificacion: "mekitec",
    label: "Inspección por rayos x",
    logo: require("@/assets/Mekitec_logo.png"),
    alt: "Mekitec_logo.png",
  },
  {
    clasificacion: "fumex",
    label: "Extractores de humo",
    logo: require("@/assets/Fumex_logo.png"),
    alt: "Fumex_logo.png",
  },
];

export type Equipo = {
  nombre: string;
  codigo: string;
  imgShowRoom: string;
  img: string;
  alt: string;
  descripcion: string;
  video: string;
  clasificacion: string;
  features: Array<{
    titulo: string;
    descripcion: string;
  }>;
};

export const EQUIPOS: Array<Equipo> = [
  {
    nombre: "SELLADORA DE BOLSAS DE BANDA CONTINUA",
    codigo: "RS140",
    img: require("@/assets/Equipos/Riqtech/RS140_Alfapack_Propuesta_Web_equipos.jpg"),
    imgShowRoom: require("@/assets/Equipos/Riqtech/RS140_Alfapack_Propuesta_Web_equipos_2500x1285.jpg"),
    alt: "RS180_Alfapack_Propuesta_Web_equipos.jpg",
    descripcion:
      "La selladora de bolsas de banda continua RS140 es perfecta para sellar herméticamente una amplia variedad de materiales de bolsas de plástico, como polietileno, polipropileno, laminados, Tyvek y bolsas aluminizadas, inclusive bolsas con pliegue o cualquier material sensible al calor. Resuelve problemas de eficiencia al automatizar parcialmente el proceso, contribuye a mantener la frescura de los productos y garantiza la seguridad del operador. ¡Integrarla en tu línea de producción es pan comido!",
    video: "T2zdpoZMq7g",
    clasificacion: "riqtech",
    features: [
      {
        titulo: "EXTIENDE LA VIDA ÚTIL DEL PRODUCTO",
        descripcion:
          "Nuestra selladora industrial logra un sello completamente hermético, cuenta con barras de calor y de enfriamiento de 5” que ayudan a realizar un sello uniforme de 1⁄4”, disponibles también en sellos de 1/8”, 3/8” , 7/16” y 1⁄2” opcionalmente. Prolonga la frescura y la vida útil de los productos.",
      },
      {
        titulo: "BRINDA PROTECCIÓN",
        descripcion:
          "La RS140 realiza el sello con bandas de teflón laminadas, sus sellos seguros previenen la apertura espontánea de las bolsas, reduciendo el desperdicio y mejorando la calidad.",
      },
      {
        titulo: "OPTIMIZA EL ESPACIO",
        descripcion:
          "Facilita un envasado eficiente, y su tamaño compacto permite ahorrar espacio en la planta, reduciendo costos. Tiene un fácil ajuste de altura del cabezal de sellado.",
      },
      {
        titulo: "AUMENTA LA EFICIENCIA",
        descripcion:
          "Semi-automatiza el proceso de envasado para reducir el tiempo y el esfuerzo manual, aumenta la eficiencia y reduce los costos laborales. Construidas en acero inoxidable y aluminio anodizado reforzado para una operación 24/7.",
      },
      {
        titulo: "AUMENTA LAS VENTAS",
        descripcion:
          "Las bolsas selladas de forma profesional mejoran la presentación de los productos en el mercado y por ende, la probabilidad de ser adquiridas.",
      },
      {
        titulo: "PROTEGE AL OPERADOR",
        descripcion:
          "Diseñadas ergonómicamente para proteger a los usuarios de lesiones. Permite sellar bolsas con peso de hasta 600 g.",
      },
    ],
  },
  {
    nombre: "SELLADORAS DE BOLSAS DE BANDA CONTINUA CON TRANSPORTADOR",
    codigo: "RS100C",
    imgShowRoom: "",
    img: require("@/assets/Equipos/Riqtech/RS100C_Alfapack_Propuesta_Web_equipos.jpg"),
    alt: "RS100C_Alfapack_Propuesta_Web_equipos.jpg",
    descripcion:
      "La selladora de bolsas de banda continua RS140 es perfecta para sellar herméticamente una amplia variedad de materiales de bolsas de plástico, como polietileno, polipropileno, laminados, Tyvek y bolsas aluminizadas, inclusive bolsas con pliegue o cualquier material sensible al calor. Resuelve problemas de eficiencia al automatizar parcialmente el proceso, contribuye a mantener la frescura de los productos y garantiza la seguridad del operador. ¡Integrarla en tu línea de producción es pan comido!",
    video: "",
    clasificacion: "riqtech",
    features: [
      {
        titulo: "EXTIENDE LA VIDA ÚTIL DEL PRODUCTO",
        descripcion:
          "Nuestra selladora industrial logra un sello completamente hermético, cuenta con barras de calor y de enfriamiento de 5” que ayudan a realizar un sello uniforme de 1⁄4”, disponibles también en sellos de 1/8”, 3/8” , 7/16” y 1⁄2” opcionalmente. Prolonga la frescura y la vida útil de los productos.",
      },
    ],
  },
  {
    nombre: "SELLADORA DE BOLSAS DE BANDA CONTINUA",
    codigo: "RS100",
    img: require("@/assets/Equipos/Riqtech/RS100_Alfapack_Propuesta_Web_equipos.jpg"),
    imgShowRoom: "",
    alt: "RS100_Alfapack_Propuesta_Web_equipos.jpg",
    descripcion:
      "La selladora de bolsas de banda continua RS140 es perfecta para sellar herméticamente una amplia variedad de materiales de bolsas de plástico, como polietileno, polipropileno, laminados, Tyvek y bolsas aluminizadas, inclusive bolsas con pliegue o cualquier material sensible al calor. Resuelve problemas de eficiencia al automatizar parcialmente el proceso, contribuye a mantener la frescura de los productos y garantiza la seguridad del operador. ¡Integrarla en tu línea de producción es pan comido!",
    video: "",
    clasificacion: "riqtech",
    features: [
      {
        titulo: "EXTIENDE LA VIDA ÚTIL DEL PRODUCTO",
        descripcion:
          "Nuestra selladora industrial logra un sello completamente hermético, cuenta con barras de calor y de enfriamiento de 5” que ayudan a realizar un sello uniforme de 1⁄4”, disponibles también en sellos de 1/8”, 3/8” , 7/16” y 1⁄2” opcionalmente. Prolonga la frescura y la vida útil de los productos.",
      },
    ],
  },
  {
    nombre: "SELLADORA DE BOLSAS DE BANDA CONTINUA",
    codigo: "RS150",
    img: require("@/assets/Equipos/Riqtech/RS140Banda_Continua_Alfapack_Propuesta_Web_equipos.jpg"),
    imgShowRoom: "",
    alt: "RS140Banda_Continua_Alfapack_Propuesta_Web_equipos.jpg",
    descripcion:
      "La selladora de bolsas de banda continua RS140 es perfecta para sellar herméticamente una amplia variedad de materiales de bolsas de plástico, como polietileno, polipropileno, laminados, Tyvek y bolsas aluminizadas, inclusive bolsas con pliegue o cualquier material sensible al calor. Resuelve problemas de eficiencia al automatizar parcialmente el proceso, contribuye a mantener la frescura de los productos y garantiza la seguridad del operador. ¡Integrarla en tu línea de producción es pan comido!",
    video: "",
    clasificacion: "riqtech",
    features: [
      {
        titulo: "EXTIENDE LA VIDA ÚTIL DEL PRODUCTO",
        descripcion:
          "Nuestra selladora industrial logra un sello completamente hermético, cuenta con barras de calor y de enfriamiento de 5” que ayudan a realizar un sello uniforme de 1⁄4”, disponibles también en sellos de 1/8”, 3/8” , 7/16” y 1⁄2” opcionalmente. Prolonga la frescura y la vida útil de los productos.",
      },
    ],
  },
];

export function useEquipos(clasificacion = "todos") {
  const currentEquipo: Ref<Equipo | null> = ref(null);
  const equipos: Ref<Array<Equipo | null>> = ref([]);

  function getEquiposByClasificacion(clase: string) {
    if (clase === "todos") return EQUIPOS;
    return EQUIPOS.filter((equipo) => equipo.clasificacion === clase);
  }

  function initialize() {
    equipos.value = getEquiposByClasificacion(clasificacion);
    currentEquipo.value = equipos.value[0] || null;
  }

  return {
    currentEquipo,
    equipos,
    initialize,
    getEquiposByClasificacion,
  };
}
